class EditSystems {
    constructor() {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');

        new EditSystemForm();
        this.editSystemIcon();
    }
    editSystemIcon(){
        /** In create system form */
        $(document).on('click', '.edit-system-icon-btn', function(e) {
            new bootstrap.Modal(document.getElementById('change_system_icon_modal'), {}).show();
            changeIconAfterClick(this);
        });

        const changeIconAfterClick = function (editBtn) {
            $(document).one('click', '#change_system_icon_modal .symbol', function(e) {
                let img = $(this).find('img');
                let iconSrc = (img[0].getAttribute('src')).replace(/ /g, "%20");
                $(editBtn).parent().find('img').attr('src',iconSrc);
                $(editBtn).parent().find('input[name="iconID"]').val(img[0].getAttribute('data-value'));
                bootstrap.Modal.getInstance(document.getElementById('change_system_icon_modal')).hide();
            });
        }
    }
}
window.EditSystems = EditSystems;